import { AuthProvider, useAuth } from '@polvo-labs/react-auth'
import { LocalStorageAdapter } from '@polvo-labs/react-auth-local-storage-adapter'
import axios from 'axios'
import React, { useEffect } from 'react'
import { BrowserRouter, Route, Switch, useHistory } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.min.css'
import Cookies from 'universal-cookie'
import AdminArea from './areas/Admin'
import CommonArea from './areas/Common'
import Loader from './components/Loader'
import auth from './config/auth'
import env from './config/env'
import routes from './config/routes'
import RoomsContextProvider from './context/rooms-context'
import { SocketProvider } from './Socket'

const StorageAdapter = new LocalStorageAdapter()

const RouteredApp = () => {
  const history = useHistory()
  function handleRequest(config: any): any {
    const url: string = config.url
    if (url.endsWith('api/user')) {
      config.url = `${env.apiURL}/user`
    }
    return config
  }

  const cookies = new Cookies()
  useEffect(() => {
    let mounted = true
    if(mounted){
      cookies.set('__tawkuuid', 'no cookies should be used in this site', { path: '/', domain:'*.iptu.app' })

    }
    return () => {
      mounted = false
    }
  }, [])

  axios.interceptors.request.use(
    request => handleRequest(request),
  )
  return (
    <AuthProvider
      storageAdapter={StorageAdapter}
      config={auth}
      handleUnauthorizedPrivateAccess={() => {
        history.push(routes.login.path)
        return false
      }}
      handleUnauthorizedGuestAccess={() => {
        history.push(routes.index.path)
      }}
      loader={(
        <Loader
          full
        />
      )}
    >
      <SocketProvider>
        <RoomsContextProvider>
          <AxiosInterceptorProvider>
            <Switch>
              <Route
                path="/admin/"
                component={AdminArea}
              />
              <Route
                path="/"
                component={CommonArea}
              />
            </Switch>
          </AxiosInterceptorProvider>
        </RoomsContextProvider>
      </SocketProvider>
    </AuthProvider>
  )
}
export interface AxiosInterceptorProviderProps {
  children?: JSX.Element
}
const AxiosInterceptorProvider: React.FC<AxiosInterceptorProviderProps> = ({ children }) => {
  const { token } = useAuth()
  function handleRequest(config: any): any {
    if (!config.headers?.Authorization) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  }

  axios.interceptors.request.use(
    request => handleRequest(request),
  )

  return (
    <>
      {children}
    </>
  )
}

const App = () => (
  <BrowserRouter>
    <RouteredApp />
  </BrowserRouter>
)

export default App
